var ResponsiveFilterColumn = React.createClass({
  propTypes: {
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      className: "filter-col"
    }
  },
  getInitialState() {
    return {
      isOpen: false
    }
  },
  toggleOpen() {
    let newState = !this.state.isOpen;
    this.setState({isOpen: newState});

    if (newState) {
      document.addEventListener("click", this.documentClicked);
    } else {
      document.removeEventListener("click", this.documentClicked);
    }
  },
  documentClicked(e) {
    let $target = $(e.target);
    let $parent = $(this.refs.parent);

    if ($target.closest($parent).length == 0) {
      this.toggleOpen();
    }
  },
  filterColClicked(e) {

  },

  render() {
    let className = classNames(this.props.className, {open: this.state.isOpen});
    const childrenWithProps = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        isOpen: this.state.isOpen,
      });
    });

    return (
      <section className={className} ref="parent" onClick={this.filterColClicked}>
        <div className="filter-toggle" onClick={this.toggleOpen}>
          <i className="glyphicon glyphicon-filter"></i>
        </div>
        {childrenWithProps}
      </section>
    )
  }
});